import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Idl } from '@project-serum/anchor';
import { toRefs } from 'vue';

type TypeKind = 'type' | 'account' | 'argument';


export default /*#__PURE__*/_defineComponent({
  props: {
    type: null,
    idl: null,
    kind: { default: 'type' },
    initialStatus: { default: 'Parsed' },
    close: null
  },
  setup(__props: any) {

const props = __props as { type: { name: string, type: object }, idl: Idl, kind: TypeKind, initialStatus: string, close:() => void }



const {
  type, idl, kind, initialStatus, close,
} = toRefs(props);

return (_ctx: any,_cache: any) => {
  const _component_anchor_type_explorer = _resolveComponent("anchor-type-explorer")!
  const _component_base_sidepage = _resolveComponent("base-sidepage")!

  return (_openBlock(), _createBlock(_component_base_sidepage, {
    close: _unref(close),
    title: _unref(type).name,
    subtitle: `Explore the ${_unref(kind)}'s schema.`
  }, {
    default: _withCtx(() => [
      _createVNode(_component_anchor_type_explorer, {
        type: _unref(type),
        idl: _unref(idl),
        "initial-status": _unref(initialStatus)
      }, null, 8, ["type", "idl", "initial-status"])
    ]),
    _: 1
  }, 8, ["close", "title", "subtitle"]))
}
}

})